export default `
  mutation removeUserFromSubscription($email: String!) {
    removeUserFromSubscription(email: $email) {
      success
      message
    }
  }
`
